<script>
import Layout from '@layouts/main'
import { mapGetters } from 'vuex'
import { getHotelRoomType, postHotelRoomTypeStore } from '@src/router/views/hotel/api'

export default {
  data() {
    return {
      activeTab: this.$route.query.tab || (this.$route.query.name ? null : '0'),
      tabList: Object.freeze([
        {
          title: '基本資訊',
          component: () => import('@/src/router/views/hotel/ModifyRoom/BasicTab.vue'),
        },
        {
          title: '房型照片',
          component: () => import('@/src/router/views/hotel/ModifyRoom/PhotoTab.vue'),
        },
        {
          title: '房價設定',
          component: () => import('@/src/router/views/hotel/ModifyRoom/PriceTab.vue'),
        },
      ]),
      roomData: null,
    }
  },
  computed: {
    roomId() {
      return this.$route.params.id || null
    },
    isResetDisabled() {
      // 禁用取消按鈕
      // 當處於圖片編輯分頁時，由於圖片組件具有即時刪除/上傳特性
      // 為了避免用戶誤以為「取消」能恢復已被物理刪除的檔案，故予以禁用
      return Number(this.activeTab) === 1
    },
    ...mapGetters('hotel/setting', ['productId', 'productName']),
  },
  components: {
    Layout,
  },
  watch: {
    activeTab(newValue) {
      this.$router.push({
        query: {
          tab: `${newValue}`,
        },
      })
    },
    roomId: {
      handler(newId) {
        if (newId) {
          this.fetchHotelRoomTypeData(newId)
        }
      },
      immediate: true,
    },
  },
  mounted() {
    if (!this.productId && !this.productName) {
      this.$confirm('請返回房型列表重新進入', '載入錯誤', {
        confirmButtonText: '確定',
        type: 'error',
        showCancelButton: false,
        showClose: false,
      }).then(() => {
        this.exit()
        this.$message({
          type: 'success',
          message: '已返回房型列表頁面',
        })
      })
    }
  },
  methods: {
    async fetchHotelRoomTypeData(roomId) {
      try {
        this.roomData = null
        const res = await getHotelRoomType(this.productId, roomId)
        console.log('取得房型成功:', res)
        this.roomData = res.items
      } catch (error) {
        console.error('取得房型資料失敗:', error)
        this.$message.error('取得房型資料失敗，請稍後再試')
      }
    },
    async onClickSaved() {
      const currentComponent = this.$refs[this.activeTab]
      if (!currentComponent) return

      if (currentComponent.validateForm) {
        const isValid = await currentComponent.validateForm()
        if (!isValid) return
      }
      const stepData = currentComponent.getStepData()
      console.log(stepData)

      const finalPayload = {
        ...this.roomData,
        ...stepData,
      }
      this.fetchUpdatedRoomType(finalPayload)
    },
    async fetchUpdatedRoomType(payload) {
      const loading = this.$loading({ lock: true, text: '儲存中，請稍候...' })
      try {
        await postHotelRoomTypeStore(payload)
        this.$message.success('儲存成功')
        await this.fetchHotelRoomTypeData(this.roomId)
      } catch (error) {
        console.log('更新房型設定錯誤', error)
        this.$message.error('儲存失敗')
      } finally {
        loading.close()
      }
    },
    exit() {
      this.$router.push('/hotel?tab1=1')
    },
    onClickReset() {
      const currentComponent = this.$refs[this.activeTab]
      if (!currentComponent) return

      currentComponent.resetData()
      this.$message.success('已還原回修改前設定')
    },
  },
}
</script>

<template>
  <Layout>
    <el-tabs v-model="activeTab" stretch type="border-card" class="isStyleBase">
      <el-tab-pane v-for="(tab1, index1) in tabList" :key="index1" :label="tab1.title" :name="`${index1}`"> </el-tab-pane>
    </el-tabs>
    <component :is="tabList[activeTab].component" :room-data="roomData" :ref="activeTab" />
    <div class="footer">
      <el-button class="is-round" :disabled="isResetDisabled" @click="onClickReset">取消編輯</el-button>
      <el-button class="is-round" type="primary" @click="onClickSaved">
        <span>儲存編輯</span>
      </el-button>
    </div>
  </Layout>
</template>

<style lang="scss" scoped>

.footer {
  box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.14);
  display: flex;
  justify-content: center;
  position: fixed;
  bottom: 0;
  left: $size-sidebar-width;
  z-index: $layer-page-footer-z-index;
  width: calc(100% - #{$size-sidebar-width});
  padding: 20px 0;
  padding-left: 5%;
  padding-right: 5%;
  text-align: center;
  background-color: white;

  > * {
    flex: 1 0 0;
  }
}
</style>
